import { SecretsManagerProviderAws } from './internal/aws'
import { SecretsManagerProvider } from './internal/provider'

class Service {
  private instance: SecretsManagerProvider

  constructor() {}

  private async setup(): Promise<void> {
    if (this.instance) {
      return
    }

    try {
      this.instance = new SecretsManagerProviderAws()
    } catch (error) {
      console.warn(`Could not setup secrets manager provider`)
    }
  }

  async getSecret(secretId: string): Promise<string> {
    await this.setup()

    return this.instance.getSecret(secretId)
  }
}

export const SecretsManagerService = new Service()
